export default __webpack_public_path__ + "static/media/unicons.b5ae9656.woff2";